import React from 'react';
const sassStyles = require('../ViewTemplates.scss');

export default props => {
  const {children} = props;
  return (
    <div className={sassStyles.noTemplates} style={props.style}>
      <img className={sassStyles.monster} src={require('../../AccountPage/EBayAccounts/images/monsterTemplates.svg')}/>
      <div className={sassStyles.headLine}>You Haven’t Created a Design Template Yet.</div>
      {children ?
        children :
        [
          <p key={0}>To start, click “CREATE NEW TEMPLATE” and customize a theme to your needs.</p>,
          <p key={1}>Once you save a template, you’ll be able to apply it to your listings in bulk or one at a time.</p>,
        ]
      }
    </div>
  );
};
